module.exports = __webpack_public_path__ + "static/search-db524b4f86a2ccc8d890208ad012ff43.png";